import apiClient from "services/ApiClient";
import type { ResponseModel } from "services/ApiClient/responseModel";
import { API_ROUTES } from "definitions/constants/routeConstants";
import { generatePath } from "react-router";
import type { Group, GroupDetail } from "./types";

const BASE_PATH = API_ROUTES.groups.base;

/**
 * Fetch groups with query string (consumed by GenericTable).
 *
 * Supported query params (passed through by GenericTable's useQueryString):
 *   - pagination[page], pagination[per_page]
 *   - group_type: team | department | location | role
 *   - q: name substring match (ILIKE)
 */
export async function fetchGroups(query: string, signal?: AbortSignal): Promise<ResponseModel<Group[]>> {
  return apiClient
    .performRequest<ResponseModel<Group[]>>(`${BASE_PATH}${query}`, undefined, signal)
    .then((response) => response.payload);
}

/**
 * Get a single group with its members. `apiClient.get` automatically unwraps
 * the outer `{ data: ... }` envelope, so the resolved value is `GroupDetail`
 * directly — not wrapped.
 */
export async function getGroup(id: number | string): Promise<GroupDetail> {
  return apiClient.get<GroupDetail>(generatePath(API_ROUTES.groups.show, { id: String(id) }));
}
